import { render, staticRenderFns } from "./the-use-of-colour.vue?vue&type=template&id=41b5ff84&scoped=true&"
import script from "./the-use-of-colour.vue?vue&type=script&lang=js&"
export * from "./the-use-of-colour.vue?vue&type=script&lang=js&"
import style0 from "./the-use-of-colour.vue?vue&type=style&index=0&id=41b5ff84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b5ff84",
  null
  
)

export default component.exports